import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Cookies from 'js-cookie'
import axios from 'axios'
import { BASE_URL } from './commonComponents/ApiEndpoints'
import { useAuth } from './AuthContext'
import TransferCertificate from './TransferCertificate'
import TransferCertificateShriHit1 from '../TransferCertificateShriHit1'

/** Matches API check for Shri Hit transfer certificate template */
const isShriHitTransferCertificateCode = (code) => {
  const normalized = String(code || '').toUpperCase()
  return normalized === 'SHRIHITTC1'
}

const getAuthToken = (user) => {
  if (user?.token) return user.token
  try {
    const userCookie = Cookies.get('user')
    return userCookie ? JSON.parse(userCookie)?.token : ''
  } catch {
    return ''
  }
}

const hasShriHitTransferCertificateTemplate = (templates) => {
  if (!Array.isArray(templates)) return false
  return templates.some(
    (item) =>
      String(item?.template_type || '').toLowerCase() ===
        'transfer_certificate' &&
      isShriHitTransferCertificateCode(item?.template_code),
  )
}

/**
 * Same route (/TransferCertificate/:id): picks Shri Hit template when institute
 * has transfer_certificate + SHRIHITTC1; else TransferCertificate.
 * Template codes are fetched on mount (before View Transfer Certificate).
 */
export default function TransferCertificateView() {
  const { user } = useAuth()
  const [loading, setLoading] = useState(true)
  const [useShriHitTemplate, setUseShriHitTemplate] = useState(false)

  useEffect(() => {
    let cancelled = false

    const fetchTemplateCodes = async () => {
      const instituteId = Number(Cookies.get('institute_id'))
      const token = getAuthToken(user)

      if (!Number.isFinite(instituteId) || instituteId <= 0 || !token) {
        if (!cancelled) {
          setUseShriHitTemplate(false)
          setLoading(false)
        }
        return
      }

      try {
        setLoading(true)
        const response = await axios.get(`${BASE_URL}/templates/codes`, {
          params: { template_type: 'transfer_certificate' },
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
            'Institute-Id': instituteId,
          },
        })

        const templates = Array.isArray(response.data?.data)
          ? response.data.data
          : []

        if (!cancelled) {
          setUseShriHitTemplate(hasShriHitTransferCertificateTemplate(templates))
        }
      } catch {
        if (!cancelled) {
          setUseShriHitTemplate(false)
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    fetchTemplateCodes()
    return () => {
      cancelled = true
    }
  }, [user?.token])

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '50vh' }}
      >
        <Spinner animation="border" role="status" />
      </div>
    )
  }

  return useShriHitTemplate ? (
    <TransferCertificateShriHit1 />
  ) : (
    <TransferCertificate />
  )
}
